import { ABORT_ERROR_SIGNATURES } from '@/domains/common/abort';
import { initPostHog } from '@/external/posthog/client';
import * as Sentry from '@sentry/nextjs';

// NEXT_PUBLIC_* vars are statically inlined by Next.js at build time —
// settings.ts is server-only, so we have to read process.env directly here.
const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENV ?? 'unknown',
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    ignoreErrors: ABORT_ERROR_SIGNATURES,
  });
}

initPostHog();

// Required so Next.js can report client-side navigation timings to Sentry.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
